import React from 'react';

const iconBg = {
  blue:   { bg: 'rgba(0,255,240,0.08)',   color: 'var(--aqua)' },
  green:  { bg: 'rgba(52,211,153,0.10)',  color: '#34D399' },
  red:    { bg: 'rgba(255,64,96,0.10)',   color: '#FF4060' },
  yellow: { bg: 'rgba(251,191,36,0.10)',  color: '#FBBF24' },
  purple: { bg: 'rgba(167,139,250,0.10)', color: '#A78BFA' },
  orange: { bg: 'rgba(251,146,60,0.10)',  color: '#FB923C' },
};

function StatCard({ title, value, subtitle, icon, color = 'blue', trend }) {
  const ic = iconBg[color] || iconBg.blue;

  return (
    <div
      className="card hover:shadow-aqua-sm transition-all cursor-default"
      style={{ borderColor: 'rgba(0,255,240,0.08)' }}
      onMouseEnter={e => e.currentTarget.style.borderColor='rgba(0,255,240,0.18)'}
      onMouseLeave={e => e.currentTarget.style.borderColor='rgba(0,255,240,0.08)'}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>{title}</p>
          <p className="text-2xl font-bold mt-1.5 font-mono" style={{ color: 'var(--text)' }}>{value}</p>
          {subtitle && <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>}
        </div>
        {icon && (
          <div
            className="w-11 h-11 rounded-xl flex items-center justify-center text-lg flex-shrink-0"
            style={{ background: ic.bg, color: ic.color }}
          >
            {icon}
          </div>
        )}
      </div>
      {trend && (
        <div className="mt-3 pt-3 text-xs" style={{ borderTop: '1px solid rgba(0,255,240,0.06)', color: 'var(--text-muted)' }}>
          {trend}
        </div>
      )}
    </div>
  );
}

export default StatCard;
